(section_name=>{
  var root = document.querySelector('.' + section_name);
  if(!root) return;

  // Visual countdown: decreases every second, loops back to start when it hits zero
  var h = root.querySelector('[data-hfb-cd="h"]'),
      m = root.querySelector('[data-hfb-cd="m"]'),
      s = root.querySelector('[data-hfb-cd="s"]');
  if(h && m && s){
    var START = 2*3600 + 5*60 + 4; // 02:05:04
    var t = START;
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function render(){
      h.textContent = pad(Math.floor(t / 3600));
      m.textContent = pad(Math.floor((t % 3600) / 60));
      s.textContent = pad(t % 60);
    }
    render();
    setInterval(function(){
      t = (t <= 0) ? START : t - 1;
      render();
    }, 1000);
  }

  // Sticky CTA: shown from reason 4 downward, hidden while the buy-box CTA is visible
  var bar = root.querySelector('.hfb-stickybar');
  if(!bar) return;
  var trigger = root.querySelector('#acc-hfb-reason-4');
  var buyCta  = root.querySelector('#acc-hfb-buy-cta');
  var atReason4 = false;
  var buyCtaVisible = false;

  function update(){
    bar.classList.toggle('hfb-is-visible', atReason4 && !buyCtaVisible);
  }

  if('IntersectionObserver' in window){
    if(trigger){
      new IntersectionObserver(function(e){
        var en = e[0];
        atReason4 = en.isIntersecting || en.boundingClientRect.top < 0;
        update();
      }, {threshold:0}).observe(trigger);
    } else {
      atReason4 = true;
    }
    if(buyCta){
      new IntersectionObserver(function(e){
        buyCtaVisible = e[0].isIntersecting;
        update();
      }, {threshold:0}).observe(buyCta);
    }
  } else {
    atReason4 = true;
  }
  update();
})("acc_hfb_lp_01_01");
